import { render, staticRenderFns } from "./BecomeReseller.vue?vue&type=template&id=1e1f7282"
import script from "./BecomeReseller.vue?vue&type=script&lang=js"
export * from "./BecomeReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports